export enum TemplateFileType {
	EXCLUSION = 'beneficiary_delete_many',
	INCLUSION = 'beneficiary_create_many',
	TRANSFER = 'beneficiary_transfer_many',
	UPDATE = 'beneficiary_update_many',
}
